import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

import session from '@/store/modules/session';
import meitavDash from '@/store/modules/meitav-dash';
import authentication from '@/store/modules/authentication';
import signup from '@/store/modules/signup';
import cityAndStreet from '@/store/modules/cityAndStreet';
import lightup from '@/store/modules/lightup';
import customerPii from '@/store/modules/customerPii';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  modules: ['signup', 'authentication'],
});

export default new Vuex.Store({
  modules: {
    session,
    lightup,
    authentication,
    signup,
    meitavDash,
    cityAndStreet,
    customerPii,
  },
  plugins: [vuexLocal.plugin],
});
